import api from '../../server';
import { decrypt, getCookie } from "../../utils"

export default {
  namespaced: true,
  state: {
    name: '',
    mobile: '',
    city: getCookie("a_city") ? getCookie("a_city") : "",
    area: '',
    address: '',
    bonus: { name: "", value: 0 },
    bonuslist: { data: [] },
    active: 2,
    choose: 2,
    zhimatips: false,
    couponVisible: false,
    position: localStorage.position !== undefined ? JSON.parse(localStorage.position) : {},
    userip: localStorage.userip !== undefined ? JSON.parse(localStorage.userip) : {},
    info: localStorage.info !== undefined ? JSON.parse(localStorage.info) : {},
    dialogVisibleValue: false
  },
  actions: {
    fetchBonusList ({ commit }, { params }) {
      return api.BonusList(params).then(data => commit('setBonusList', { data }))
    },
    fetchBonusGrant ({ commit }, { params }) {
      return api.bountGrant(params).then(data => commit('setBonusGrant', { data }))
    },
    fetchEarthLottery ({ commit }, { params }) {
      return api.EarthFeach(params).then(data => commit('setEarthFeach', { data }))
    },
    fetchLotteryOrder ({ commit }, { params }) {
      return api.lotteryOrder(params).then(data => commit('setLotteryOrder', { data }))
    },
    fetchBountGrant ({ commit }, { params }) {
      return api.bountGrant(params).then(data => commit('setBounsGrant', { data }))
    },
  },
  mutations: {
    setName (state, name) {
      state.name = name
    },
    setCity (state, city) {
      state.city = city
    },
    setAddress (state, address) {
      state.address = address
    },
    setBonus (state, bonus) {
      state.bonus = bonus
    },
    setActive (state, active) {
      state.active = active
    },
    setcouponVisible (state, visible) {
      state.couponVisible = visible
    },
    setChoose (state, id) {
      state.choose = id
    },
    setArea (state, value) {
      state.area = value
    },
    setZhimaTips (state, value) {
      state.zhimatips = value
    },
    setBonusList (state, value) {
      state.bonuslist = value.data
    },
    setBonusGrant (state, value) {
      state.bonusgrant = value
    },
    setUserInfo (state, value) {
      state.info = value
    },
    setVisibleValue (state, value) {
      state.dialogVisibleValue = !state.dialogVisibleValue
    },
  }
}
